// Keeps links to a loyalty section (e.g. /pages/programme-de-fidelite#referral) aligned below the
// sticky header, including when images or member data change the layout after the initial jump.
const SETTLE_TIMEOUT_MS = 4000;
const STOP_EVENTS = ['wheel', 'touchstart', 'keydown', 'mousedown'];

const header = document.querySelector('.header-section');

function updateOffset() {
  const offset = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
  document.documentElement.style.setProperty('--loyalty-anchor-offset', `${offset}px`);
}

function hashTarget() {
  let id = '';
  try {
    id = decodeURIComponent(window.location.hash.slice(1));
  } catch {
    return null;
  }
  const target = id ? document.getElementById(id) : null;
  return target?.classList.contains('loyalty') ? target : null;
}

function keepAligned(target) {
  const align = () => target.scrollIntoView({ block: 'start' });
  const observer = new ResizeObserver(align);
  const stop = () => {
    observer.disconnect();
    STOP_EVENTS.forEach((type) => window.removeEventListener(type, stop));
  };

  observer.observe(document.querySelector('main') || document.body);
  if (header) observer.observe(header);
  STOP_EVENTS.forEach((type) => window.addEventListener(type, stop, { passive: true }));
  window.setTimeout(stop, SETTLE_TIMEOUT_MS);
}

if (!window.loyaltyAnchorReady) {
  window.loyaltyAnchorReady = true;
  updateOffset();
  if (header) new ResizeObserver(updateOffset).observe(header);

  const target = hashTarget();
  if (target) keepAligned(target);
}
